/**
 * @generated SignedSource<<3bc087200671ed5fe4b5ebe76bd474f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PractitionerFilterType = "COACH" | "THERAPIST" | "DIETITIAN" | "%future added value";
export type ValidateVerifyUserEmailInput = {
  token: string;
};
export type authValidateVerifyUserEmailQuery$variables = {
  input: ValidateVerifyUserEmailInput;
  skip: boolean;
};
export type authValidateVerifyUserEmailQuery$data = {
  readonly validateVerifyUserEmail?: {
    readonly email: string;
    readonly countryId: string | null;
    readonly practitionerType: PractitionerFilterType | null;
  };
};
export type authValidateVerifyUserEmailQuery = {
  variables: authValidateVerifyUserEmailQuery$variables;
  response: authValidateVerifyUserEmailQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "VerifyResponse",
        "kind": "LinkedField",
        "name": "validateVerifyUserEmail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "practitionerType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authValidateVerifyUserEmailQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authValidateVerifyUserEmailQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2977e2cc1ce18a6202fa32012e1c4ca4",
    "id": null,
    "metadata": {},
    "name": "authValidateVerifyUserEmailQuery",
    "operationKind": "query",
    "text": "query authValidateVerifyUserEmailQuery(\n  $input: ValidateVerifyUserEmailInput!\n  $skip: Boolean!\n) {\n  validateVerifyUserEmail(input: $input) @skip(if: $skip) {\n    email\n    countryId\n    practitionerType\n  }\n}\n"
  }
};
})();

(node as any).hash = "4fdc539c5848df8343c73fb14efc1bfe";

export default node;
